(() => {
  function init(root) {
    const slider = root.querySelector('[data-slider]');
    if (!slider) return;

    const list = slider.querySelector('.slides');
    const slides = Array.from(slider.querySelectorAll('.slide'));
    if (!list || slides.length === 0) return;

    let index = 0;
    let autoplay = (root.dataset.autoplay || 'false') === 'true';
    let interval = parseInt(root.dataset.interval || '5000', 10);
    let timer = null;

    function update() {
      list.style.transform = `translateX(${-index * 100}%)`;
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      update();
    }

    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(() => go(index + 1), interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Pausar rotação quando o usuário interage/está vendo outra aba
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    update();
    start();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement').forEach(init);
  });
})();
